import {
  Collapse,
  TableCell,
  TableRow,
  Typography,
  useTheme,
  useMediaQuery,
  Box,
} from '@mui/material'
import { useTranslation } from 'react-i18next'

import { EConsumerChallengeStatus, ETranslationNs, IChallengeWithStats } from 'src/types'

import { useStyles } from './../../styles'
import { UtcAndLocalDatesCell } from 'src/components/utc-and-local-dates-cell'
import { CollapsedItem } from './collapsed-item.component'
import { LeaderboardTable } from './challenge-leaderboard.component'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  collapsed: boolean
  item: IChallengeWithStats
  userTz?: string
}

export const BodyRowCollapse = ({ collapsed, item, userTz }: IProps) => {
  const [t] = useTranslation([ETranslationNs.Common])
  const classes = useStyles()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('laptop'))

  return (
    <TableRow
      sx={{
        maxWidth: '1024px',
      }}
    >
      <TableCell colSpan={9} className={classes.cell}>
        <Collapse in={collapsed} timeout="auto" unmountOnExit>
          <ul className={classes.collapsedContent}>
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-name-column" />}
              node={<Typography sx={{ fontSize: '14px' }}>{item.name}</Typography>}
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-description-label" />}
              node={<Typography sx={{ fontSize: '14px' }}>{item.description}</Typography>}
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-start-date-label" />}
              node={
                <Typography>
                  <UtcAndLocalDatesCell
                    date={item.start_date}
                    loalTimezone={userTz}
                    // withoutUtc
                    localDateFontSize={'14px'}
                    utcDateFontSize={'12px'}
                    containerSx={{ alignItems: 'start' }}
                  />
                </Typography>
              }
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-end-date-label" />}
              node={
                <Typography>
                  <UtcAndLocalDatesCell
                    date={item.end_date}
                    loalTimezone={userTz}
                    // withoutUtc
                    localDateFontSize={'14px'}
                    utcDateFontSize={'12px'}
                    containerSx={{ alignItems: 'start' }}
                  />
                </Typography>
              }
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-trai-amount-label" />}
              node={
                <Typography sx={{ fontSize: '14px' }}>
                  {Number(item.trai_pool).toLocaleString()}
                </Typography>
              }
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-total-points-label" />}
              node={
                <Typography sx={{ fontSize: '14px' }}>
                  {Number(item.totalPoints).toLocaleString()}
                </Typography>
              }
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-total-scans-label" />}
              node={
                <Typography sx={{ fontSize: '14px' }}>
                  {Number(item.scans_created).toLocaleString()}
                </Typography>
              }
            />
            <CollapsedItem
              title={<HelperWrapper t="consumer-challenges-unique-scanners-label" />}
              node={
                <Typography sx={{ fontSize: '14px' }}>
                  {Number(item.unique_scanners).toLocaleString()}
                </Typography>
              }
            />

            {item.leaderboard && item.leaderboard.length > 0 && (
              <Box sx={{ my: 1 }}>
                <Typography
                  fontSize={'14px'}
                  fontWeight={700}
                  sx={{ mb: item.status === EConsumerChallengeStatus.ONGOING ? '4px' : '8px' }}
                >
                  <HelperWrapper t="consumer-challenges-leaderboard-label" />
                </Typography>
                {item.status === EConsumerChallengeStatus.ONGOING && (
                  <Typography fontSize={'11px'} sx={{ mb: 1, color: theme.palette.custom.grey2 }}>
                    <HelperWrapper t="consumer-challenges-leaderboard-note-text" />
                  </Typography>
                )}
                <LeaderboardTable
                  challangeName={item.name}
                  leaderboard={item.leaderboard}
                  userPlacement={item.userPlacement}
                />
              </Box>
            )}
          </ul>
        </Collapse>
      </TableCell>
    </TableRow>
  )
}
